import IncrementalIndexedAdapter from 'lokijs/src/incremental-indexeddb-adapter';
/** @type {"NODEJS" | "BROWSER" | "NATIVESCRIPT" | "CORDOVA" | "NA"} */
export const env = 'BROWSER';
export default IncrementalIndexedAdapter;
